<div class="container">
  <div class="container-form">
    <div class="header">
      <img alt="" src="../../../assets/images/safe-gis-logo.svg" />
      <h1 *ngIf="isLoginPage">Login:</h1>
      <h1 *ngIf="!isLoginPage">Recuperação de Senha:</h1>
    </div>

    <form [formGroup]="form" (ngSubmit)="submitForm()" action="" *ngIf="isLoginPage">
      <div class="container-input">
        <h4>Usuário</h4>
        <input
          type="text"
          id="user"
          name="user"
          formControlName="user"
          placeholder="Usuário"
        />
        <span *ngIf="form.get('user')?.invalid && form.get('user')?.touched">Campo obrigatório</span>
      </div>
      <div class="container-input">
        <h4> Senha </h4>
        <input
          [type]="showPassword ? 'text' : 'password'"
          id="password"
          name="password"
          formControlName="password"
          placeholder="Senha"
        />
        <button
          type="button"
          class="material-icons"
          (click)="togglePasswordVisibility()"
        >
          {{ showPassword ? 'visibility_off' : 'visibility' }}
        </button>
        <span *ngIf="form.get('password')?.invalid && form.get('password')?.touched">Campo obrigatório</span>
      </div>
      <button class="recuperar-senha" type="button">
        <span (click)="setRecuperarSenhaPage()" style="cursor: pointer;">
          Esqueci minha senha
        </span>
      </button>
      <button type="submit" class="button blue" style="width: 100%;">
        Entrar
      </button>
    </form>

    <form [formGroup]="formEsqueciSenha" (ngSubmit)="submitFormEsqueciSenha()" action="" *ngIf="!isLoginPage">
      <div class="container-input">
        <h4>E-mail</h4>
        <input
          type="email"
          id="email"
          name="email"
          formControlName="email"
          placeholder="E-mail"
        />
        <span *ngIf="formEsqueciSenha.get('email')?.invalid && formEsqueciSenha.get('email')?.touched">
          Campo obrigatório
        </span>
      </div>
      <div class="container-button">
        <button type="submit" class="button green-outline">
          <img src="../../../assets/images/icons/arrow-white.svg" alt="">
          Confirmar
        </button>
        <button type="button" (click)="setLoginPage()" class="button red-outline">
          <img src="../../../assets/images/icons/close-white.svg" alt="">
          Cancelar
        </button>
      </div>
    </form>
  </div>
</div>
